import { useState } from "react";
import styles from './styles.module.scss';
import { useLivekitRoom } from "../../hooks/useLivekitRoom"; // импортируем наш хук
import { useLocation, useHistory } from "react-router-dom";
import { useWindowSize } from "../../hooks/useWindowSize";
import * as UI from '../../components/ConferenceComponents'
import { MainContext } from "../../utils/context";
import { LIVEKIT_URL } from '../../assets/const'
import { useDispatch } from "react-redux";
import { getToken } from '../../actions/main'
import { nanoid } from "nanoid";



const Main = () => {

  const dispatch = useDispatch()
  const {pathname} = useLocation()
  const history = useHistory()
  const { width } = useWindowSize();
  const livekitData = useLivekitRoom({ serverUrl: LIVEKIT_URL });

  const { room, joinRoom } = livekitData
  
  const [roomName] = useState(pathname.split("/")[1] || `SessionA-${Date.now()}`)
  const [view, setView] = useState(4);
  const [initiator] = useState(!pathname.split("/")[1])



  const onSubmit = async (values) => {
    const { videoDeviceId, audioDeviceId, ...metaData } = values    
    const mediaParams = {videoDeviceId, audioDeviceId}
    try {
      // const id = nanoid(10)
      const id = metaData.username
      const token = await dispatch(getToken(roomName, id, metaData));
      await joinRoom(token, mediaParams);
      history.push(`/${roomName}`);
    } catch (err) {
      console.error("Ошибка при подключении:", err);
    }
  }

  

  const contextValue = {...livekitData, initiator, roomName}
  
  return (
    <MainContext.Provider value={contextValue}>
      <UI.Resume/>
      {!room ? (
        <UI.Form onSubmit={onSubmit} roomName={roomName}/>
      ) : (
        <>
          {/* {width > 560 && <UI.ChooseLayout view={view} changeView={setView} />} */}
          <div className={styles.container}>
            <UI.FoolScreen />
            <UI.Controllers/>
            {/* <UI.Chat /> */}
            {/* {view === 1 && <UI.View1 />} */}
            {/* {view === 2 && <UI.View2 />} */}
            {/* {view === 3 && <UI.View3 />} */}
            {view === 4 && <UI.View4 />}
            {/* {view === 5 && <UI.View5 />} */}
          </div>
        </>
      )}
    </MainContext.Provider>
  );
}

export default Main;
